if (!customElements.get('q-shop-shelf')) {
  customElements.define('q-shop-shelf', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.q7-product-track');
      this.slots = [...this.querySelectorAll('.q7-product-slot')];
      this.prev = this.querySelector('[data-shelf-prev]');
      this.next = this.querySelector('[data-shelf-next]');
      this.controls = this.querySelector('.q7-shelf-controls');
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.querySelector('.q7-tabs')?.removeAttribute('hidden');
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.slots.forEach(slot => { slot.hidden = button.dataset.filter !== 'all' && !slot.dataset.brew.split(' ').includes(button.dataset.filter); });
        this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.update();
        this.querySelector('.q7-shelf-status').textContent = `${this.visible.length} محاصيل / coffees`;
      }, opts));
      this.prev.addEventListener('click', () => this.move(-1), opts);
      this.next.addEventListener('click', () => this.move(1), opts);
      this.track.addEventListener('scroll', () => this.update(), { ...opts, passive: true });
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track) return;
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          if (e.key === 'Home') this.go(0);
          else if (e.key === 'End') this.go(this.max);
          else this.move((e.key === 'ArrowLeft') === this.rtl ? 1 : -1);
        }
      }, opts);
      this.addEventListener('shopify:block:select', e => {
        const slot = e.target.closest('.q7-product-slot');
        if (!slot) return;
        if (slot.hidden) this.querySelector('[data-filter="all"]')?.click();
        this.update();
        this.go(this.visible.indexOf(slot) * this.step);
      }, opts);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      this.visible = this.slots.filter(s => !s.hidden);
      const css = getComputedStyle(this.track);
      this.rtl = css.direction === 'rtl';
      this.step = (this.visible[0]?.getBoundingClientRect().width || 0) + (parseFloat(css.columnGap) || 0);
      this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const offset = Math.min(this.max, Math.abs(this.track.scrollLeft));
      this.prev.disabled = offset < 2;
      this.next.disabled = offset >= this.max - 2;
      this.controls.hidden = this.max < 2;
      const fraction = this.track.scrollWidth ? (offset + this.track.clientWidth) / this.track.scrollWidth : 1;
      this.querySelector('.q7-shelf-progress>span').style.width = `${Math.min(1, fraction) * 100}%`;
    }
    move(dir) { this.go(Math.round(Math.abs(this.track.scrollLeft) / this.step) * this.step + dir * this.step); }
    go(offset) { this.track.scrollTo({ left: Math.max(0, Math.min(offset, this.max)) * (this.rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
    disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); }
  });
  document.addEventListener('click', e => { const link = e.target.closest('a[data-shop-brew]'); if (link) document.querySelector(`#q-shop-coffee [data-filter="${link.dataset.shopBrew}"]`)?.click(); });
  const openFinder = () => { if (location.hash === '#q-coffee-finder') { const finder = document.querySelector('details#q-coffee-finder'); if (finder) finder.open = true; } };
  document.addEventListener('click', e => { if (e.target.closest('a[href="#q-coffee-finder"]')) { const finder = document.querySelector('details#q-coffee-finder'); if (finder) finder.open = true; } });
  window.addEventListener('hashchange', openFinder);
  openFinder();
}
